<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar('')"></button>
    </div>
    <div class="modal-body text-center">
        <div class="icons">
            <div class="swal2-icon swal2-question">?</div>
        </div>

        <h4>¿Está seguro?</h4>
        <p [innerHTML]="mensaje"></p>
    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnCancel" type="button" class="btn btn-light" (click)="cerrar('cancelar')">Cancelar</button>
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="cerrar('aceptar')">Aceptar</button>
    </div>
</div>
